var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var defaultLoadConfig = {
    nftExplorerBaseURL: null,
    pluginBaseURL: "https://cdn.live.ledger.com",
    extraPlugins: null
};
export function getLoadConfig(userLoadConfig) {
    return __assign(__assign({}, defaultLoadConfig), userLoadConfig);
}
//# sourceMappingURL=loadConfig.js.map